<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-02-12 18:04 -->
<!-- Description:  -->
<template>
  <select name="" id=""
    v-model="localValue" class="custom-select"
    @change="$emit('change', $event)">
    <option value=""></option>
    <option v-for="(l, i) in list" :key="i" :value="l.id">{{ l.slug }}</option>
  </select>
</template>
<script>
import AdminService from "../AdminService.js";

// script content
export default {
  name: "PermissionSelectFromAll",
  components: {
    //
  },

  // directives

  props: {
    value: {}
  },

  data: () => ({
    list: []
  }),

  computed: {
    localValue: {
      get() { return this.value; },
      set(ev) { this.$emit("input", ev); }
    }
  },

  // watch: {},

  async mounted() {
    let res = await AdminService.getPermissions({ per_page: 999 });
    this.list = res.data;
  },

  methods: {
    //
    //
    //
  }
};
</script>
<style scoped></style>

